import {
  Home,
  ShoppingCart,
  Wallet,
  FileText,
  Users,
  RotateCcw,
  Settings,
  Code,
  Megaphone,
  CreditCard,
  Store,
  FileBarChart,
} from 'lucide-react';

/**
 * Navigation configuration for the sidebar
 * Using Lucide icons instead of custom SVGs
 */
export const navigationConfig = {
  payment: {
    label: '',
    items: [
      {
        id: 'home',
        label: 'Home',
        href: '/home',
        icon: Home,
      },
      {
        id: 'orders',
        label: 'Orders',
        href: '/orders',
        icon: ShoppingCart,
      },
      {
        id: 'payouts',
        label: 'Payouts & Balances',
        href: '/payouts',
        icon: Wallet,
      },
      {
        id: 'reports',
        label: 'Reports',
        href: '/reports',
        icon: FileText,
        children: [
          {
            id: 'transaction-report',
            label: 'Transaction Report',
            href: '/transaction-report',
          },
          {
            id: 'store-credit-report',
            label: 'Store Credits',
            href: '/store-credit-report',
          },
        ],
      },
      {
        id: 'customers',
        label: 'Customers',
        href: '/customers',
        icon: Users,
      },
      {
        id: 'manual-refunds',
        label: 'Manual Refunds',
        href: '/manual-refunds',
        icon: RotateCcw,
        requiresDirectPayout: true, // Only show if payout_mode is DIRECT_PAYOUT
      },
    ],
  },
  discount: {
    label: 'Discount',
    items: [
      {
        id: 'campaigns',
        label: 'Campaigns',
        href: '/campaigns',
        icon: Megaphone,
      },
    ],
  },
  bottom: {
    label: 'Bottom',
    items: [
      {
        id: 'developer',
        label: 'Developer hub',
        href: 'https://joinfam.readme.io',
        icon: Code,
        external: true,
      },
      {
        id: 'settings',
        label: 'Settings',
        href: '/settings',
        icon: Settings,
      },
    ],
  },
};

/**
 * Flatten navigation items for easy lookup
 */
export const getAllNavItems = () => {
  const items = [];
  Object.values(navigationConfig).forEach((section) => {
    section.items.forEach((item) => {
      items.push(item);
      if (item.children) {
        items.push(...item.children);
      }
    });
  });
  return items;
};

/**
 * Find nav item by path - supports exact match and parent path matching
 */
export const findNavItemByPath = (path) => {
  const allItems = getAllNavItems();
  
  // First try exact match
  const exactMatch = allItems.find((item) => item.href === path);
  if (exactMatch) return exactMatch;
  
  // Then try matching the first path segment
  const cleanPath = '/' + path.split('/')[1];
  const segmentMatch = allItems.find((item) => item.href === cleanPath);
  if (segmentMatch) return segmentMatch;
  
  // Check for nested route matches (e.g., /transaction-report is under Reports)
  const pathWithoutSlash = path.replace(/^\//, '');
  const nestedMatch = allItems.find((item) => {
    if (item.children) {
      return item.children.some(child => 
        child.href === path || child.href === cleanPath
      );
    }
    return false;
  });
  
  return nestedMatch || null;
};
